import React from "react";
import PropTypes from 'prop-types';
import { List, Card, Table } from "antd";
import ActionBtns from "../../../components/ActionBtns/ActionBtns";
import {Link, useRouteMatch} from "react-router-dom";
import '../Patients.scss'


const PatientList = (props) => {
  const { dataSource } = props;
    console.log('groups list props ===>', dataSource)
  const tableDataSource = []
  for (let index = 0; index < dataSource.length; index++) {
    let objToPush = {}
    objToPush.id = dataSource[index].id
    // objToPush.name = dataSource[index].name
    objToPush.name = <Link to={`/u/patients/${dataSource[index].id}`}> {dataSource[index].id} - {dataSource[index].first_name} {dataSource[index].last_name}</Link>



    // if(dataSource[index].disorder_information.age_options !== undefined){
    //   let suffix = ""
    //   if(dataSource[index].disorder_information.age_radio == "yes")
    //     suffix = "years"
    //   else
    //     suffix = "months"
    //   objToPush.age = dataSource[index].disorder_information.age_options + " " + suffix;
    // }
    
    objToPush.gender = dataSource[index].gender
    // objToPush.disorder = dataSource[index].disorder_information.disorder_type
    objToPush.updated_at = dataSource[index].updated_at
    objToPush.actions = <ActionBtns edit={true} id={dataSource[index].id} path="patients"/>
    tableDataSource.push(objToPush)
  }
  
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
    },
    {
      title: 'Gender',
      dataIndex: 'gender',
      key: 'gender',
    },
    {
      title: 'Disorder',
      dataIndex: 'disorder',
      key: 'disorder',
    },
    {
      title: 'Updated at',
      dataIndex: 'updated_at',
      key: 'updated_at',
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      key: 'actions',
    },
  
    
  ];
  const {path, url} = useRouteMatch();
  console.log("exp list item url", url);
  return (
      <Table dataSource={tableDataSource} columns={columns} pagination={false} />
    
  );
};
PatientList.defaultProps = {};

PatientList.propTypes = {};

export default PatientList;
